import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PieChartLine = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2C12.4477 2 12 2.44771 12 3V11C12 11.5523 12.4477 12 13 12H21C21.5523 12 22 11.5523 22 11C22 6.02944 17.9706 2 13 2ZM14 10V4.07C17.073 4.51284 19.4872 6.92698 19.93 10H14ZM19.5418 14.6651C19.7277 14.145 20.3 13.8741 20.82 14.06C21.3377 14.2439 21.61 14.811 21.43 15.33C20.4233 18.1796 18.1818 20.421 15.3323 21.4277C10.1248 23.2675 4.412 20.5374 2.57227 15.33C0.732538 10.1226 3.46259 4.40973 8.67001 2.57C9.19192 2.38775 9.76275 2.66309 9.94501 3.185C10.1273 3.70691 9.85192 4.27775 9.33001 4.46C7.05285 5.26555 5.26156 7.05684 4.45601 9.334C2.98251 13.4993 5.16468 18.0705 9.33001 19.544C13.4953 21.0175 18.0665 18.8353 19.54 14.67L19.5418 14.6651Z",
    fill: "currentColor"
  })
});